import { render, staticRenderFns } from "./CoalInforUploadRecord.vue?vue&type=template&id=d1c3c2c2&scoped=true&"
import script from "./CoalInforUploadRecord.vue?vue&type=script&lang=js&"
export * from "./CoalInforUploadRecord.vue?vue&type=script&lang=js&"
import style0 from "./CoalInforUploadRecord.vue?vue&type=style&index=0&id=d1c3c2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c3c2c2",
  null
  
)

export default component.exports